import { usePageContext } from "@outschool/ui-analytics";
import { useSession } from "@outschool/ui-auth";
import { useEffect } from "react";

import useExperiment from "./useExperiment";

/**
 * This experiment is an A/A experiment used to monitor experiment assignments and when the experiment service times out.
 * Our goal is to understand if and when users are seeing "flickering" of experiment assignments.
 * That is, when the user sees a different experiment assignment when navigating between pages or browsing a particular page.
 */
export default function useMonitorExperimentServiceTimeoutsExperiment() {
  const { pageLoadId, pageImpressionId, pagePath } = usePageContext();
  const { currentUserHasLoaded } = useSession();
  const { trigger } = useExperiment(
    "MonitorExperimentServiceTimeouts",

    // Default to a non-holdout variant so that we can still trigger (experiment service will ignore holdout variants).
    "client_holdout",
  );

  useEffect(() => {
    // Wait for relevant data to be available.
    if (
      !currentUserHasLoaded ||
      pageLoadId === undefined ||
      pageImpressionId === undefined ||
      pagePath === undefined
    ) {
      return;
    }
    // Trigger the experiment with some additional data about what page we're on.
    trigger({
      additionalProperties: { pageLoadId, pageImpressionId, pagePath },
    });
  }, [trigger, currentUserHasLoaded, pageLoadId, pageImpressionId, pagePath]);
}
